import { useEffect } from 'react';
import { api } from '@/lib/api';
import { useAuth, type EnteOpcion } from '@/lib/authStore';

type MeResp = {
  usuario: { id: string; email: string; nombre: string; roles: string[] };
  ente_actual_id: string;
  entes: EnteOpcion[];
  permisos: string[];
};

// useMe refreshes /api/auth/me once on mount when the user is authenticated,
// so Zustand's `permisos` and `entes` are kept in sync with the server.
export function useMe() {
  const token = useAuth((s) => s.token);
  const setMe = useAuth((s) => s.setMe);

  useEffect(() => {
    if (!token) return;
    const ac = new AbortController();
    api<MeResp>('/auth/me', { signal: ac.signal })
      .then((r) => setMe({ permisos: r.permisos, entes: r.entes, ente_actual_id: r.ente_actual_id }))
      .catch(() => {
        /* 401 is handled by api.ts (session cleared); other errors are silent */
      });
    return () => ac.abort();
  }, [token, setMe]);
}
